import * as jspb from "google-protobuf";
import { BookableRefList } from "../../../../gen/witbooking/backoffice/extra/v1/extra_api_pb";

const hasInventoryLines = (list: BookableRefList): boolean =>
  list.getBookableRefsList().some(ref => (ref.getInventory()?.getTickersList().length ?? 0) > 0);

/**
 * AGR children an extra is propagated to: the keys of `applies_to_agr_inventories` with at least
 * one inventory line selected. The parent is not a key, so it is not counted.
 */
export const countPropagatedProperties = (
  appliesToAgrInventories: jspb.Map<string, BookableRefList>
): number => {
  let total = 0;
  appliesToAgrInventories.forEach(list => {
    if (hasInventoryLines(list)) total += 1;
  });
  return total;
};
